let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lN50H")).then(() => parcelRequire('2DLxB'));